if (!customElements.get('m-read-more-toggle')) {
  class MReadMoreToggle extends HTMLElement {
    constructor() {
      super();
      this.description = this.querySelector('.js-overflow-text');
      this.button = this.querySelector('.js-toggle-read-more');
      this.iconPlusLine = this.querySelector('.v-line');
      this.isExpanded = false;
    }

    connectedCallback() {
      this.updateButtonVisibility();
      this.button?.addEventListener('click', this.toggleReadMore.bind(this));
      window.addEventListener('resize', this.updateButtonVisibility.bind(this));
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggleReadMore);
      window.removeEventListener('resize', this.updateButtonVisibility);
    }

    updateButtonVisibility() {
      if (!this.description || !this.button) return;
      const isOverflowing = this.description.scrollHeight > this.description.clientHeight;

      if (isOverflowing || this.isExpanded) {
        this.button.style.display = 'block';
      } else {
        this.button.style.display = 'none';
      }
    }

    toggleReadMore() {
      if (!this.description) return;

      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        this.description.classList.remove('tw-line-clamp-5');
        this.iconPlusLine.style.display = 'none';
      } else {
        this.description.classList.add('tw-line-clamp-5');
        this.iconPlusLine.style.display = 'block';
      }
      this.updateButtonVisibility();
    }
  }

  customElements.define('m-read-more-toggle', MReadMoreToggle);
}
